var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import bootstrapCommonBase from '../../styles/bootstrap/base/common';
import { linkStyle as bootstrapLinkStyle, linkScript as bootstrapLinkScript, linkUnscript as bootstrapLinkUnscript } from '../../styles/bootstrap/soul/link';
import { TiniElementTheming } from 'tinijs';
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { ref, createRef } from 'lit/directives/ref.js';
import { TiniElement, partAttrMap, VaryGroups, } from 'tinijs';
let TiniLinkComponent = class TiniLinkComponent extends TiniElement {
    constructor() {
        super(...arguments);
        this.ROUTER_CHANGE_EVENT = 'tini:router:change';
        this.anchorRef = createRef();
        this.updateActiveStatus = (e) => {
            if (!this.active || !this.anchorRef.value)
                return;
            const currentUrl = new URL(!this.href ? '/' : this.href, window.location.origin);
            const eventUrl = e?.detail.url;
            const currentActive = e
                ? currentUrl.href === `${eventUrl.origin}${eventUrl.pathname}`
                : currentUrl.href ===
                    `${window.location.origin}${window.location.pathname}`;
            // anchor tag
            const partList = this.anchorRef.value.getAttribute('part') || '';
            this.anchorRef.value.setAttribute('part', (currentActive
                ? `${partList} ${this.active}`
                : partList.replace(this.active, '')).trim());
            // the host
            this.classList[currentActive ? 'add' : 'remove'](this.active);
        };
    }
    static { this.defaultTagName = 'tini-link'; }
    static { this.componentName = 'link'; }
    /* eslint-enable prettier/prettier */
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        // root classes parts
        this.extendRootClasses({
            raw: {
                italic: !!this.italic,
                underline: !!this.underline,
            },
            overridable: {
                [VaryGroups.Color]: this.color,
                [VaryGroups.FontType]: this.fontType,
                [VaryGroups.FontSize]: this.fontSize,
                [VaryGroups.FontWeight]: this.fontWeight,
                [VaryGroups.TextTransform]: this.textTransform,
            },
        });
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.active)
            window.addEventListener(this.ROUTER_CHANGE_EVENT, this.updateActiveStatus);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.active)
            window.removeEventListener(this.ROUTER_CHANGE_EVENT, this.updateActiveStatus);
    }
    updated() {
        if (this.active)
            this.updateActiveStatus();
    }
    clickLink(e) {
        if (!this.anchorRef.value)
            return;
        // navigate
        if (this.anchorRef.value.href !== window.location.href) {
            const url = new URL(this.anchorRef.value.href);
            history.pushState({}, '', url.href);
            dispatchEvent(new PopStateEvent('popstate'));
        }
        // default
        e.preventDefault();
        window.scrollTo(0, 0);
    }
    render() {
        return html `
      <a
        router-ignore
        ${ref(this.anchorRef)}
        class=${classMap(this.rootClasses)}
        part=${partAttrMap(this.rootClasses)}
        href=${this.href || '/'}
        target=${ifDefined(this.target)}
        rel=${ifDefined(this.rel)}
        @click=${this.clickLink}
      >
        <slot></slot>
      </a>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], TiniLinkComponent.prototype, "href", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniLinkComponent.prototype, "rel", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniLinkComponent.prototype, "target", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniLinkComponent.prototype, "active", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], TiniLinkComponent.prototype, "italic", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], TiniLinkComponent.prototype, "underline", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniLinkComponent.prototype, "color", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniLinkComponent.prototype, "fontType", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniLinkComponent.prototype, "fontSize", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniLinkComponent.prototype, "fontWeight", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniLinkComponent.prototype, "textTransform", void 0);
TiniLinkComponent = __decorate([
    TiniElementTheming({
        styling: { bootstrap: [bootstrapCommonBase, bootstrapLinkStyle] },
        scripting: { bootstrap: { script: bootstrapLinkScript, unscript: bootstrapLinkUnscript } },
    })
], TiniLinkComponent);
export { TiniLinkComponent };
//# sourceMappingURL=link.js.map